module.exports = "<svg viewBox=\"0 0 14 25\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 2.987h-2.236L5.31 22.903H7c.552 0 1 .445 1 .996 0 .548-.448.994-1 .994H1c-.552 0-1-.446-1-.995 0-.552.448-.997 1-.997h2.236L8.69 2.987H7c-.552 0-1-.446-1-.996s.448-.995 1-.995h6c.552 0 1 .446 1 .996s-.448.997-1 .997z\" fill=\"#777\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/scripts/components/shared/InlineEditor/images/italic.svg
// module id = hjbO
// module chunks = 89